import { createContext, useContext } from "react";

/**
 * Permissão de EXCLUIR, resolvida uma vez no login (GET /api/me) e distribuída
 * para a árvore. O servidor é quem realmente bloqueia; aqui é só para não
 * mostrar um botão que a pessoa não pode usar.
 */
const Ctx = createContext(false);
export const PermissoesProvider = Ctx.Provider;
/** Só administradores podem excluir registros (regra do Portal). */
export const usePodeExcluir = () => useContext(Ctx);
